(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cos-bespoke-colour-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cos-bespoke-preview')) {
  customElements.define('cos-bespoke-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.scope = this.closest('.cos-bespoke-panel, #bespoke-section');
      this.root = this.closest('.product-single');
      if (!this.scope || !this.root) return;
      this.body = this.scope.matches('#bespoke-section') ? this.scope : this.scope.querySelector('[data-bespoke-body]');
      this.colourInput = this.scope.querySelector('[name="properties[Thread Colour]"]');
      this.cache = new Map();
      this.generation = 0;
      this.onChange = event => {
        if (event?.target && !this.scope.contains(event.target) && !event.target.matches('[name="edition"]')) return;
        const choice = event?.target?.closest('[data-value][data-color]');
        if (choice && this.scope.contains(choice)) { this.chosen = true; this.selectedHex = choice.dataset.color; }
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update().catch(() => { this.pending = null; this.loading = null; this.restore(); });
        });
      };
      this.root.addEventListener('click', this.onChange);
      this.root.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(this.onChange);
      this.observer.observe(this.body, {attributes:true,attributeFilter:['style','class']});
    }
    disconnectedCallback() {
      this.root?.removeEventListener('click',this.onChange);
      this.root?.removeEventListener('change',this.onChange);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.generation++;
      this.restore();
      for (const url of this.cache?.values() || []) URL.revokeObjectURL(url);
      this.cache?.clear();
      this.initialised = false;
    }
    pause() { return new Promise(resolve => setTimeout(resolve, 0)); }
    async load() {
      const readImage = url => new Promise((resolve,reject) => {
        const image = new Image(); image.crossOrigin='anonymous';
        let attempts = 0;
        image.onload=()=>resolve(image);
        image.onerror=()=>{ if (attempts++ < 1) image.src=url; else reject(new Error('Preview image unavailable')); };
        image.src=url;
      });
      // Neither image is requested until a customer actively chooses a colour.
      const [img, threadMask] = await Promise.all([
        readImage(this.dataset.source),
        this.dataset.mask ? readImage(this.dataset.mask) : Promise.resolve(null)
      ]);
      if (!this.isConnected) return;
      this.canvas=document.createElement('canvas');
      this.canvas.width=img.naturalWidth;this.canvas.height=img.naturalHeight;
      this.ctx=this.canvas.getContext('2d',{willReadFrequently:true});
      this.ctx.drawImage(img,0,0);
      this.source=this.ctx.getImageData(0,0,this.canvas.width,this.canvas.height);
      this.weights=new Float32Array(this.source.width*this.source.height);
      this.lights=new Float32Array(this.weights.length);
      const maskCanvas=document.createElement('canvas');
      maskCanvas.width=this.canvas.width;maskCanvas.height=this.canvas.height;
      const mask=maskCanvas.getContext('2d',{willReadFrequently:true});
      if (threadMask) {
        mask.drawImage(threadMask,0,0,maskCanvas.width,maskCanvas.height);
      } else {
      mask.scale(this.canvas.width/1000,this.canvas.height/1000);
      mask.fillStyle='#fff';
      const regions=[[[180,370],[211,371],[231,386],[387,346],[412,347],[418,388],[405,411],[355,431],[305,449],[258,466],[237,471],[213,469],[182,436]],[[547,354],[567,349],[612,360],[746,385],[779,362],[812,352],[832,369],[826,416],[803,448],[781,468],[747,474],[563,415],[541,390]],[[149,426],[159,405],[179,416],[196,442],[225,468],[272,489],[335,501],[398,506],[497,508],[580,502],[646,490],[698,472],[744,451],[779,422],[797,396],[821,387],[839,406],[839,430],[825,458],[802,487],[768,510],[716,532],[650,548],[587,557],[499,562],[404,556],[332,546],[270,530],[223,508],[192,482],[169,459],[151,440]],[[137,539],[151,537],[169,565],[197,589],[236,615],[285,634],[345,648],[422,653],[500,657],[584,650],[654,636],[716,616],[770,586],[807,554],[830,518],[848,524],[851,550],[839,580],[811,613],[768,643],[711,668],[653,687],[589,695],[500,703],[407,701],[337,693],[302,688],[273,679],[246,667],[219,654],[196,638],[178,620],[160,599],[146,579],[134,556],[134,548]]];
      mask.strokeStyle='#fff';mask.lineWidth=5;mask.lineJoin='round';
      for(const [regionIndex,points] of regions.entries()){mask.lineWidth=regionIndex===3?1:5;mask.beginPath();points.forEach(([x,y],i)=>i?mask.lineTo(x,y):mask.moveTo(x,y));mask.closePath();mask.fill();mask.stroke();}
      mask.globalCompositeOperation='destination-out';mask.lineWidth=8;mask.lineCap='round';
      const fittings=[[[192.857,368.571],[212.143,371.429],[225.714,381.429]],[[175.714,385.0],[193.571,389.286],[208.571,399.286]],[[166.429,400.714],[183.571,402.857],[195.0,409.286],[199.286,413.571]],[[169.286,421.429],[184.286,420.0],[195.0,422.857],[202.857,432.857]],[[184.286,440.714],[197.143,439.286],[208.571,441.429],[215.0,445.714]],[[237.857,462.857],[222.143,457.143],[207.857,462.857],[200.0,475.714],[203.571,491.429],[213.571,505.0]],[[250.714,472.143],[243.571,481.429],[237.143,497.857],[240.0,517.143]],[[295.0,486.429],[289.286,497.143],[284.286,511.429],[282.857,527.857],[287.143,534.286]],[[337.143,496.429],[330.714,514.286],[328.571,527.857],[328.571,538.571]],[[380.0,504.286],[375.0,520.0],[374.286,536.429],[376.429,548.571]],[[438.571,508.571],[435.714,527.857],[435.714,542.857],[439.286,557.143]],[[497.143,507.857],[495.714,527.143],[495.714,546.429],[497.143,558.571]],[[552.143,505.714],[556.429,524.286],[557.143,542.143],[557.143,554.286]],[[602.143,500.0],[605.714,517.143],[606.429,535.714],[604.286,547.143]],[[653.571,490.714],[664.286,504.286],[668.571,520.0],[667.857,535.0]],[[691.429,480.714],[705.714,488.571],[712.143,504.286],[715.0,521.429]],[[735.714,466.429],[750.0,471.429],[757.143,485.0],[760.0,501.429]],[[759.286,452.143],[773.571,450.0],[787.857,458.571],[795.714,475.0]],[[784.286,437.143],[799.286,431.429],[815.714,435.714],[825.0,447.143]],[[795.714,415.0],[814.286,410.0],[834.286,415.714]],[[797.143,396.429],[815.714,390.714],[835.714,392.857]],[[795.714,377.857],[812.857,370.714],[830.714,373.571]],[[785.714,364.286],[800.714,355.0],[815.0,355.714]],[[157.143,560.714],[143.571,570.0],[145.0,580.0],[152.143,587.857]],[[174.286,583.571],[166.429,592.857],[159.286,603.571],[164.286,616.429]],[[202.143,610.0],[198.571,623.571],[199.286,632.857],[207.857,643.571]],[[241.429,624.286],[234.286,638.571],[235.714,653.571],[242.143,660.0]],[[288.571,635.0],[281.429,652.857],[282.857,665.714],[290.714,675.0]],[[335.714,644.286],[329.286,660.714],[330.0,678.571],[336.429,687.143]],[[387.143,652.143],[385.0,671.429],[386.429,684.286],[390.0,695.714]],[[440.714,654.286],[442.143,675.0],[445.0,690.0],[447.857,700.0]],[[497.857,655.714],[497.143,675.714],[495.714,693.571]],[[552.143,654.286],[552.857,674.286],[552.857,692.143]],[[607.143,647.857],[608.571,663.571],[607.857,680.0]],[[658.571,637.143],[665.0,654.286],[666.429,667.143],[662.143,677.857]],[[705.0,628.571],[712.857,642.143],[716.429,657.857],[712.857,667.857]],[[756.429,617.143],[762.143,629.286],[763.571,642.143]],[[789.286,596.429],[797.143,607.143],[801.429,622.143],[797.857,631.429]],[[821.429,577.857],[829.286,588.571],[831.429,602.143]],[[838.571,555.0],[847.143,565.714],[847.857,580.0]],[[170.0,450.0],[167.143,463.571],[169.286,475.0],[180.0,488.571]]];
      for(const points of fittings){mask.beginPath();points.forEach(([x,y],i)=>i?mask.lineTo(x,y):mask.moveTo(x,y));mask.stroke();}

      }
      const maskPixels=mask.getImageData(0,0,maskCanvas.width,maskCanvas.height).data;
      const p=this.source.data, clamp=v=>Math.max(0,Math.min(1,v)), histogram=new Uint32Array(4096);
      const protectSilver=this.hasAttribute('data-protect-silver');
      const londonEdge = threadMask ? null : new Float32Array(this.canvas.width);
      const edgeFeather = this.canvas.height * 12 / 1400;
      if (londonEdge) {
        const edgePoints=[[188,766],[195,784],[217,816],[248,856],[268,879],[308,908],[360,928],[420,944],[500,962],[570,967],[650,967],[740,967],[810,961],[880,953],[960,934],[1030,921],[1100,875],[1140,844],[1165,806],[1185,773]];
        let segment=0;
        for(let x=0;x<londonEdge.length;x++) {
          const referenceX=x*1400/this.canvas.width;
          while(segment<edgePoints.length-2 && referenceX>edgePoints[segment+1][0])segment++;
          const [x0,y0]=edgePoints[segment], [x1,y1]=edgePoints[segment+1];
          londonEdge[x]=(referenceX<x0 || referenceX>x1 ? 1400 : y0+(y1-y0)*(referenceX-x0)/(x1-x0))*this.canvas.height/1400;
        }
      }
      let sampleCount=0;
      const active=[];
      for(let i=0;i<p.length;i+=4){
        if(i && i%262144===0) await this.pause();
        if(!this.isConnected) return;
        const r=p[i],g=p[i+1],b=p[i+2],max=Math.max(r,g,b),min=Math.min(r,g,b),delta=max-min;
        let weight;
        if (threadMask) {
          weight=maskPixels[i]/255;
          if(protectSilver) weight*=clamp((115-max)/55)*clamp((40-delta)/25);
        } else {
          if(!maskPixels[i+3] || max>135 || delta>35)continue;
          weight=clamp((135-max)/45)*clamp((35-delta)/20)*maskPixels[i+3]/255;
          const pixel=i/4, row=Math.floor(pixel/this.canvas.width), column=pixel%this.canvas.width;
          weight*=clamp((londonEdge[column]+edgeFeather-row)/edgeFeather);
        }
        if (!weight) continue;
        this.weights[i/4]=weight;
        active.push(i/4);
        const light=(.2126*r+.7152*g+.0722*b)/255;
        this.lights[i/4]=light;
        if(weight>.9){ histogram[Math.round(light*4095)]++; sampleCount++; }
      }
      let cumulative=0;
      this.mid=.25;
      for(let i=0;i<histogram.length && sampleCount;i++){
        cumulative+=histogram[i];
        if(cumulative>Math.floor(sampleCount*.6)){this.mid=i/4095||.25;break;}
      }
      this.activePixels = new Uint32Array(active);
      for (let i=0;i<this.activePixels.length;i++) {
        if(i && i%65536===0) await this.pause();
        const p=this.activePixels[i];
        this.lights[p]=Math.max(.45,Math.min(1.08,.92*Math.pow(this.lights[p]/this.mid,.55)));
      }
    }
    restore() {
      for(const record of this.originals||[]){
        for(const [name,value] of Object.entries(record.attrs)){
          if(value===null)record.el.removeAttribute(name);else record.el.setAttribute(name,value);
        }
      }
      this.originals=[];
      this.applied=null;
    }
    async update() {
      if(!this.isConnected)return;
      const selected=this.colourInput?.value;
      const option=Array.from(this.scope.querySelectorAll('[data-value]')).find(el=>el.dataset.value===selected);
      const hex=this.selectedHex || option?.dataset.color;
      const visible=this.body.getClientRects().length>0 && this.chosen;
      if(!visible || !/^#[0-9a-f]{6}$/i.test(hex||'')){
        this.generation++;this.pending=null;this.restore();return;
      }
      if(this.applied===hex){this.generation++;this.pending=null;return;}
      if(this.pending===hex)return;
      const generation=++this.generation;
      this.pending=hex;
      if(!this.loading) this.loading=this.load().catch(error=>{this.loading=null;this.pending=null;throw error;});
      await this.loading;
      if(generation!==this.generation || !this.isConnected)return;
      const photo=this.root.querySelector('.product-single__photos #proFeaturedImageZoom [data-position="0"] img');
      if(!photo)return;
      let url=this.cache.get(hex);
      if(!url){
      const colour=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
      const output=new ImageData(new Uint8ClampedArray(this.source.data),this.source.width,this.source.height);
      for(let index=0;index<this.activePixels.length;index++){
        if(index && index%65536===0) await this.pause();
        const p=this.activePixels[index];
        if(generation!==this.generation || !this.isConnected)return;
        const weight=this.weights[p];if(!weight)continue;
        const texture=this.lights[p];
        for(let c=0;c<3;c++){
          const base=Math.max(16,colour[c]);
          const textured=Math.min(255,base*texture);
          output.data[p*4+c]=this.source.data[p*4+c]*(1-weight)+textured*weight;
        }
      }
      this.ctx.putImageData(output,0,0);
      const blob=await new Promise(resolve=>this.canvas.toBlob(resolve,'image/png'));
      if(generation!==this.generation || !this.isConnected)return;
      if(!blob){this.pending=null;return;}
      url=URL.createObjectURL(blob);
      }
      this.cache.delete(hex);
      this.cache.set(hex,url);
      if(!this.originals?.length){
        const targets = new Map();
        for (const image of this.root.querySelectorAll('.product-single__photos #proFeaturedImageZoom [data-position="0"] img')) {
          targets.set(image, ['src','srcset','data-src','data-srcset']);
          for (const name of ['data-zoom','data-pswp-src']) {
            const parent = image.closest('['+name+']');
            if (parent) targets.set(parent, [...new Set([...(targets.get(parent) || []), name])]);
          }
        }
        this.originals=Array.from(targets, ([el,names])=>({el,attrs:Object.fromEntries(names.map(name=>[name,el.getAttribute(name)]))}));
      }
      for(const record of this.originals){
        for(const name of Object.keys(record.attrs)){
          if(name==='srcset'||name==='data-srcset')record.el.removeAttribute(name);
          else record.el.setAttribute(name,url);
        }
      }
      this.applied=hex;
      this.pending=null;
      while(this.cache.size>4){
        const oldest=this.cache.keys().next().value;
        URL.revokeObjectURL(this.cache.get(oldest));this.cache.delete(oldest);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
